.card {
  position: relative;
  background: var(--color-surface-tertiary);
  border-radius: var(--card-border-radius);
  overflow: hidden;
  border: 1px solid var(--card-bg-color);

  &[data-is-selected='true'] {
    border-color: var(--color-secondary);
  }
}

.header {
  padding-top: 62.5%;
  position: relative;
  z-index: 1;

  &:hover + #action {
    display: initial;
  }

  &:hover > #action {
    display: initial;
  }

  &:hover #action {
    display: initial;
  }

  h1 {
    font-family: Inter, sans-serif;
    color: var(--step-title-color);
  }

  cursor: pointer;
}

.content {
  padding: 0.8rem 1.6rem 1.6rem 1.6rem;
}

.name {
  font-weight: 700;
  font-size: 1.4rem;
  line-height: 1.9rem;
  color: #f7f8f8;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  display: block;
  white-space: nowrap;
}

.address {
  display: flex;
  align-items: center;
  margin-top: 0.8rem;

  svg {
    fill: #959bab;
    height: 1.4rem;
    width: 1.4rem;
    margin-right: 0.8rem;
  }

  > span {
    display: inline-block;
    min-height: 100%;
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-weight: 400;
    font-size: 1.4rem;
    color: #959bab;
  }
}

.dropdown-container {
  position: absolute;
  top: 1.2rem;
  right: 1.2rem;
  cursor: pointer;
  z-index: 99;
}
